





















import { Component, Vue } from "vue-property-decorator";
import AccountingComponent from "../components/AccountingComponent.vue";
import emitter from "@/EventBus";
import AccountingSearchOptions from "@/ui/common/presenters/accounting-search-options";
import { client } from "@/api/request";
import { InvoicePayment } from "@/usecases/accounting/invoice";
import { isNewProject } from "@/preferences";
import { PrintNewOrder } from "@/api/orders/print-api";
import {
  changeStatusAccouting,
  IStatusAccouting
} from "@/api/accounting/status-api";
import PaymentInfoModal from "@/ui/order/components/PaymentInfoModal.vue";
import PaymentInvoicePage from "@/ui/order/pages/PaymentInvoicePage.vue";
import { cloneDeep, uniqBy } from "lodash";
import { StateChanger } from "vue-infinite-loading";
import format from "date-fns/format";

@Component({
  components: {
    AccountingComponent,
    PaymentInfoModal,
    PaymentInvoicePage
  },
  methods: {
    isNewProject
  }
})
export default class AccountingInvoice extends Vue {
  invoiceSearch = {};
  invoiceItems: InvoicePayment[] = [];
  resetLoadInfinite = 0;
  invoice: any = "";
  isPositionPrinting: number = -1;

  fields = [
    { key: "estimateNumber", label: "見積書No" },
    { key: "invoiceNumber", label: "請求書No" },
    { key: "dateOfIssue", label: "	発行日" },
    { key: "projectName", label: "現場" },
    { key: "title", label: "	件名" },
    { key: "projectClientName", label: "	請求先" },
    { key: "status", label: "ステータス" },
    { key: "total", label: "金額" },
    {
      key: "actions",
      label: "",
      thStyle: { width: "100px" },
      tdStyle: { width: "100px" }
    }
  ];

  created() {
    emitter.on("initData", data => {
      this.invoiceSearch = data as AccountingSearchOptions;
    });
  }

  currentOptions(currentLength: number, options?: { projectName: string }) {
    const new_options = {
      ...options,
      invoiceCount: currentLength
    };

    return new_options;
  }

  async getInvoiceList30(options?: any) {
    const new_options = this.currentOptions(this.invoiceItems.length, options);
    const newInvoiceItems = await client.get("get_invoice.php", new_options);

    return newInvoiceItems;
  }

  async loadInfinite($state: any) {
    const loadedInvoiceItems = await this.getInvoiceList30(this.invoiceSearch);

    if (loadedInvoiceItems.invoices.length) {
      this.invoiceItems = uniqBy(
        this.invoiceItems.concat(loadedInvoiceItems.invoices),
        "id"
      );
      $state.loaded();
    } else {
      $state.complete();
    }

    if (loadedInvoiceItems.invoices.length < 30) {
      $state.complete();
      return;
    }
  }

  async changeStatus(item: InvoicePayment, status: string) {
    const option: IStatusAccouting = {
      id: item.id,
      projectId: item.projectId,
      status,
      model: "Invoice"
    };
    try {
      const id = await changeStatusAccouting(option);
      this.updateInvoice(id, { status });
    } catch (error) {
      alert(error);
    }
  }

  async handleCreatePdf(item: any, index: number) {
    if (this.isPositionPrinting !== -1) {
      alert(
        "現在他の見積書で印刷を生成中です。時間をおいてからもう一度試してください。"
      );

      return;
    }
    this.isPositionPrinting = index;
    let options: PrintNewOrder = {
      id: item.id,
      accessToken: this.$store.state.accessToken,
      printsExcludeTax: item.printsExcludeTax
    };

    if (isNewProject(item.projectCreated)) {
      options = {
        ...options,
        orderNew: 1
      };
    }

    try {
      const data = await client.get("create_invoice_pdf.php", options);
      window.open(data.pdf, "発注書印刷");
    } catch (error) {
      alert(error);
    } finally {
      this.isPositionPrinting = -1;
    }
  }

  handleShowModal(item: InvoicePayment) {
    if (!item.paymentDate) {
      item.paymentDate = format(new Date(), "yyyy-MM-dd");
    }
    this.invoice = cloneDeep(item);
    (this.$refs.paymentModal as any).show();
  }

  async saveInvoice(invoice: InvoicePayment) {
    const {
      status,
      note,
      amountReceived,
      paymentDate,
      requestedDate
    } = invoice;
    const data = {
      id: invoice.id,
      status,
      note,
      amount_received: amountReceived,
      payment_date: paymentDate,
      requested_date: requestedDate,
      type: "Invoice"
    };

    try {
      const res = await client.post("save_payment_info.php", data);
      this.updateInvoice(res.id, {
        status,
        note,
        amountReceived,
        paymentDate,
        requestedDate
      });
      (this.$refs.paymentModal as any).hide();
    } catch (error) {
      alert(error);
    }
  }

  updateInvoice(id: number, data: Record<string, string | number>) {
    const index = this.invoiceItems.findIndex(item => item.id == id);

    if (index !== -1) {
      Vue.set(this.invoiceItems, index, {
        ...this.invoiceItems[index],
        ...data
      });
    }
  }

  handleSearch($state: StateChanger) {
    this.invoiceItems = [];
    $state.reset();
  }
}
